import SocialProfileRoutes from './SocialProfileRoutes';

export default SocialProfileRoutes;
